import { useState } from "react";
import { ChevronDown } from "lucide-react";
import type { Account } from "@/lib/finance";

const MONTHS = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
export const monthYear = (iso?: string | null) => (iso ? `${MONTHS[Number(iso.slice(5, 7)) - 1]} ${iso.slice(0, 4)}` : "");

interface Props { title: string; testId: string; accounts: Account[]; detail: (a: Account) => string }

export function ClosedAccountsSection({ title, testId, accounts, detail }: Props) {
  const [open, setOpen] = useState(false);
  if (accounts.length === 0) return null;
  return (
    <div className="rounded-[14px] border border-[#DDE1E8] bg-white px-5" data-testid={testId}>
      <button onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between py-4 text-sm font-semibold text-[#1B2A4A]" data-testid={`${testId}-toggle`} aria-expanded={open}>
        <span>{title} ({accounts.length})</span>
        <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="divide-y divide-[#DDE1E8] border-t border-[#DDE1E8]">
          {accounts.map((a) => (
            <li key={a.id} className="flex flex-col gap-0.5 py-3 text-sm sm:flex-row sm:items-center sm:justify-between" data-testid={`${testId}-row-${a.id}`}>
              <span className="font-medium text-[#1B2A4A]">{a.name}</span>
              <span className="text-slate-500">{detail(a)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
